document.addEventListener("DOMContentLoaded", () => {
    // Créer un IntersectionObserver global pour les éléments de la galerie produit
    const visibilityObserver = window.innerWidth >= 768 
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
              } else {
                entry.target.classList.remove("is-visible");
              }
            });
          },
          { threshold: 0.10 }
        )
      : null;

    // Fonction pour observer les éléments de la galerie
    const observeGalleryMedia = (container = document) => {
      const items = container.querySelectorAll(".product-gallery__media:not([data-visibility-observed])");
      items.forEach((item) => {
        item.setAttribute("data-visibility-observed", "true");
        if (visibilityObserver) {
          visibilityObserver.observe(item);
        } else {
          item.classList.add("is-visible");
        }
      });
    };

    // Observer les éléments existants au chargement
    observeGalleryMedia();

    // Observer les changements du DOM pour les éléments ajoutés dynamiquement (ex: quick-buy-modal)
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Vérifier si le noeud ajouté est un élément de galerie ou contient des éléments de galerie
            if (node.classList?.contains("product-gallery__media")) {
              node.setAttribute("data-visibility-observed", "true");
              if (visibilityObserver) {
                visibilityObserver.observe(node);
              } else {
                node.classList.add("is-visible");
              }
            }
            observeGalleryMedia(node);
          }
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });